












import { Component, Prop, Vue } from 'vue-property-decorator';
import PdfThumbnailItem from './pdf-thumbnail-item.vue';

@Component({
    name: 'PdfDocumentThumbnail',
    components: { PdfThumbnailItem }
})
export default class PdfDocumentThumbnail extends Vue {
    @Prop({ type: Array })
    documents!: any[];

    @Prop()
    currentDocument!: any;

    @Prop()
    imageBaseUrl!: String
}
